import { HttpResponseCode } from '@/types';

export const HttpResponseCodeConstants = {
  handledHttpResponseCodes: [HttpResponseCode.BadRequest, HttpResponseCode.NotFound,
  HttpResponseCode.Unauthorized, HttpResponseCode.InternalServerError, HttpResponseCode.GatewayTimeout,
  HttpResponseCode.Forbidden]
};